import { defineStore } from 'pinia';
import { chunk } from 'lodash';

import { HotelSelectionListDataType } from '../../models';
import type {
  HotelSelectionCardData,
  HotelSelectionListData,
} from '../../models';

export const useHotelSelectionListStore = defineStore(
  'HotelSelectionListStore',
  () => {
    // State
    const isFirstHotelSelectionListRender = true;

    // Actions
    function getFormattedData(
      data: HotelSelectionCardData[],
      numberOfChunks: number
    ): HotelSelectionListData[] {
      const result: HotelSelectionListData[] = [];
      chunk(data, numberOfChunks).forEach((item, index) => {
        result.push({
          type: HotelSelectionListDataType.HotelCard,
          data: item,
          id: index,
        });
      });

      // NOTE: Temporary remove rendering of Sembo Benefits
      // const semboBenefitsIndex = 3;
      // const semboBenefitsData: HotelSelectionListData = {
      //   type: HotelSelectionListDataType.SemboBenefits,
      //   id: semboBenefitsIndex,
      // };
      // if (result.length > semboBenefitsIndex) {
      //   result.splice(semboBenefitsIndex, 0, semboBenefitsData);
      //   result.forEach((item, index) => {
      //     if (index > semboBenefitsIndex) {
      //       result[index] = { ...item, id: index };
      //     }
      //   });
      // } else {
      //   result.push(semboBenefitsData);
      // }

      return result;
    }

    return {
      // State
      isFirstHotelSelectionListRender,

      // Actions
      getFormattedData,
    };
  }
);
